import { useMemo } from 'react'
import ReactQuill from 'react-quill'
import { DeltaStatic, Sources } from 'quill'
import { EditorProps } from 'Types/Presentation/Components/Editor'
import 'react-quill/dist/quill.snow.css'

import useViewModel from './ViewModel'
import { htmlToText } from 'html-to-text'
import clsx from 'clsx'

const Editor: React.FC<EditorProps> = ({
	readOnly,
	modules,
	formats,
	limitCharacter,
	value,
	onChange,
	placeholder,
	style,
	height,
}) => {
	const { editorRef } = useViewModel(limitCharacter)
	const characterLeft = useMemo(() => {
		if (limitCharacter) {
			if (editorRef.current?.unprivilegedEditor) {
				if (htmlToText(value as any) === '' || (value as any) === '<p><br></p>') {
					return limitCharacter
				} else {
					return limitCharacter - htmlToText(value as any).length
				}
			}
		}

		return 0
	}, [limitCharacter, editorRef, value])

	const onChangeEditor = (
		newValue: string,
		delta: DeltaStatic,
		source: Sources,
		editor: ReactQuill.UnprivilegedEditor
	) => {
		if (onChange) {
			onChange(editor.getHTML(), delta, source, editor)
		}
	}

	return (
		<>
			<ReactQuill
				ref={editorRef}
				readOnly={readOnly}
				theme="snow"
				modules={modules}
				formats={formats}
				value={value}
				placeholder={placeholder}
				onChange={onChangeEditor}
				style={style}
				className={characterLeft < 0 ? 'overlimit-character' : ''}
			/>

			{limitCharacter && (
				<div
					className={clsx('mt-2', {
						'text-kumopack-grey-600': characterLeft >= 0,
						'text-kumopack-error-600': characterLeft < 0,
					})}>
					{characterLeft} characters left
				</div>
			)}

			{height && (
				<style>
					{`
					.ql-container.ql-snow {
						height: ${height}px;
					}

					.overlimit-character .ql-toolbar, .overlimit-character .ql-container {
						border: 1px solid #f1416c !important;
					}	

					.overlimit-character .ql-container {
						border-top: none !important;
					}
				`}
				</style>
			)}
		</>
	)
}

export default Editor
